import { requestParamsByTypeFilterType } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/constants";
import { TypeFilterEnum } from "~/feature/dashboard/components/sortAndFilters/TypeFilterDropdown/types";

interface IGetTypeFilterValueProps {
  oneMarket?: boolean;
  hasDisputedMarkets?: boolean;
  minEventCount?: number;
  hasBreakingMarket?: boolean;
  hasTrendingMarket?: boolean;
}

export const getTypeFilterValue = (value: IGetTypeFilterValueProps) => {
  const matched = Object.values(TypeFilterEnum).find((type) => {
    const requestParams = requestParamsByTypeFilterType[type];
    return (
      requestParams.oneMarket === value.oneMarket &&
      requestParams.hasDisputedMarkets === value.hasDisputedMarkets &&
      requestParams.minEventCount === value.minEventCount &&
      requestParams.hasBreakingMarket === value.hasBreakingMarket &&
      requestParams.hasTrendingMarket === value.hasTrendingMarket
    );
  });

  return matched ?? null;
};
